import React from 'react'

import clsx from 'clsx'

import Card, { CardActionArea } from 'components/Card'
import ClickoutWrapper from 'components/ClickoutWrapper'
import Icon from 'components/Icon'
import { FixedImage } from 'components/NextImage'
import Rating from 'components/Rating'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import classes from './ItemCard.module.scss'

const ItemCard = ({
  listing: { is_premium: isPremium, cta_urls, name, logo_url, rating_avg, num_reviews },
  className,
  eventProps = {},
  listingPosition,
}) => {
  const { addEvent } = useEventContext()

  return (
    <Card className={clsx('ItemCard', classes.root, className)} elevation={0}>
      <ClickoutWrapper
        role="presentation"
        url={isPremium ? cta_urls.cta : cta_urls.detail}
        isClickout={isPremium}
        listingPosition={listingPosition}
        {...addEvent({ ...eventProps, productClickPosition: listingPosition })}
      >
        <CardActionArea className={classes.contender}>
          <div className={classes.logo}>
            <FixedImage fetchWidth={72} width={40} src={logo_url} alt="logo" />
          </div>
          <div className={classes.info}>
            <div className={classes.nameWrapper}>
              <div className={classes.name}>
                <Typography component="span" variant="body-xs" className={classes.titleHeadingExp}>
                  {name}
                </Typography>
              </div>
              {isPremium && <Icon icon={['far', 'external-link']} size="12" className={classes.externalLink} />}
            </div>

            <Rating.Link className={classes.rating} average={rating_avg} totals={num_reviews} isCompact />
          </div>
        </CardActionArea>
      </ClickoutWrapper>
    </Card>
  )
}

export default ItemCard
